<template>
  <div class="createCurriculumSystem">
    <p class="title">课程详情</p>
    <el-divider></el-divider>
    <el-form
      class="form-style"
      label-width="120px"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item label="课程名称" required prop="curriculum_name">
        <el-input
          v-model="ruleForm.curriculum_name"
          placeholder="请输入名称"
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item label="课程科目" required prop="subject_id">
        <el-select
          v-model="ruleForm.subject_id"
          placeholder="请选择"
          style="width: 300px"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) of subjectList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类别" required prop="teaching_type">
        <el-select
          v-model="ruleForm.teaching_type"
          placeholder="请选择"
          style="width: 300px"
        >
          <el-option label="面授课" :value="1"></el-option>
          <el-option label="直播课" :value="2"></el-option>
          <el-option label="录播课" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序号" required prop="sort_num">
        <el-input-number
          v-model="ruleForm.sort_num"
          :precision="0"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="课程次数" required prop="number_of_courses">
        {{ ruleForm.number_of_courses }}
      </el-form-item>
      <el-form-item label="课程资料" required>
        <el-upload
          action=""
          :http-request="uploadFile"
          :on-remove="
            (file, fileList) => handleRemove(file, fileList, 'curriculum_url')
          "
          :on-change="
            (file, fileList) =>
              handleChangeFile(file, fileList, 'curriculum_url')
          "
          :auto-upload="false"
          multiple
          :file-list="ruleForm.curriculum_url"
          style="width: 300px"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div style="margin: 30px 0 30px 100px">
      <el-button @click="updateCurriculumInfo" type="primary">保存</el-button>
    </div>
    <div class="table-style">
      <el-table
        :data="ruleForm.curriculum_classes_list"
        border
        :header-cell-style="{ background: '#f5f7fa' }"
      >
        <el-table-column prop="id" label="序号"></el-table-column>
        <el-table-column prop="title" label="课程名称"></el-table-column>
        <el-table-column label="所属科目">
          <template>
            {{ curriculum_name }}
          </template>
        </el-table-column>
        <el-table-column prop="sort_num" label="排序号"></el-table-column>
        <el-table-column label="课程资源" width="340px">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="downLoad(scope.row.video_url_first)"
              >课程视频1</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="downLoad(scope.row.video_url_second)"
              >课程视频2</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="openPpt(scope.row.teaching_materials_url)"
              >讲义</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="openPpt(scope.row.ppr_url)"
              >PPT</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80px;">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="editCurriculum(scope.row, scope.$index)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="编辑课程信息" :visible.sync="dialogVisible">
      <el-form class="form-style" label-width="120px" ref="subjectRuleForm">
        <el-form-item label="课程名称" required>
          <el-input
            v-model="curriculumRow.title"
            placeholder="请输入名称"
            size="small"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序号" required>
          <el-input-number
            v-model="curriculumRow.sort_num"
            size="small"
            :precision="0"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="课程视频1">
          <el-upload
            action=""
            :limit="1"
            :http-request="uploadFile"
            :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'video_url_first')
            "
            :on-change="
              (file, fileList) =>
                handleChangeFile(file, fileList, 'video_url_first')
            "
            :auto-upload="false"
            :file-list="curriculumRow.video_url_first"
            style="width: 300px"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="课程视频2">
          <el-upload
            action=""
            :limit="1"
            :http-request="uploadFile"
            :on-remove="
              (file, fileList) =>
                handleRemove(file, fileList, 'video_url_second')
            "
            :on-change="
              (file, fileList) =>
                handleChangeFile(file, fileList, 'video_url_second')
            "
            :auto-upload="false"
            :file-list="curriculumRow.video_url_second"
            style="width: 300px"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="讲义">
          <el-input
            v-model="curriculumRow.teaching_materials_url"
            placeholder="请输入url"
            style="width: 300px"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="PPT" required>
          <el-input
            v-model="curriculumRow.ppt_url"
            placeholder="请输入url"
            style="width: 300px"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quitAddSubject">取 消</el-button>
        <el-button type="primary" @click="addSubject">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserSubjectList } from "@/api/user";
import { getCurriculumInfo, updateCurriculumInfo } from "@/api/educational";
import uploadFile from "@/config/uploadFile";
export default {
  name: "createCurriculumSystem",
  data() {
    return {
      uploadFileTime: false,
      dialogVisible: false,
      subjectList: [],
      ruleForm: {
        subject_id: "",
        teaching_type: "",
        number_of_courses: 1,
        sort_num: 1,
        curriculum_name: "",
        curriculum_url: [],
        curriculum_classes_list: [],
      },
      curriculum_name: "",
      curriculumRow: {
        created_time: null,
        curriculum_id: null,
        id: null,
        ppt_url: "",
        remarks: null,
        sort_num: null,
        subject_id: null,
        teaching_materials_url: "",
        title: null,
        url: null,
        video_url_first: [],
        video_url_second: [],
      },
      curriculumRowIndex: 0,
      rules: {
        curriculum_name: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        teaching_type: [
          { required: true, message: "请选择类别", trigger: "change" },
        ],
        number_of_courses: [
          { required: true, message: "请输入课程次数", trigger: "change" },
        ],
        sort_num: [
          { required: true, message: "请输入排序号", trigger: "change" },
        ],
        subject_id: [
          { required: true, message: "请选择科目", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.getUserSubjectList();
    this.getCurriculumInfo();
  },
  methods: {
    openPpt(url) {
      window.open(url)
    },
    // 编辑课程体系
    updateCurriculumInfo(status) {
      if (!this.ruleForm.curriculum_name) {
        this.$message.warning("请填写课程名称");
        return;
      }
      if (!this.ruleForm.curriculum_url.length) {
        this.$message.warning("请上传课程资料");
        return;
      }
      updateCurriculumInfo({
        curriculum_id: this.$route.query.id,
        curriculum_name: this.ruleForm.curriculum_name,
        subject_id: this.ruleForm.subject_id,
        teaching_type: this.ruleForm.teaching_type,
        number_of_courses: this.ruleForm.number_of_courses,
        sort_num: this.ruleForm.sort_num,
        curriculum_url: JSON.stringify(this.ruleForm.curriculum_url),
        curriculum_classes_list: JSON.stringify(
          this.ruleForm.curriculum_classes_list
        ),
      }).then(() => {
        this.$message.success("修改成功");
        if (status === "edit") {
          this.dialogVisible = false;
          this.getCurriculumInfo();
        } else {
          this.$router.push({ name: "own-class-management" });
        }
      });
    },
    // 下载文件
    downLoad(url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$message.warning("文件未上传");
      }
    },
    editCurriculum(row, index) {
      console.log(row)
      this.curriculumRow.created_time = row.created_time;
      this.curriculumRow.curriculum_id = row.curriculum_id;
      this.curriculumRow.id = row.id;
      this.curriculumRow.remarks = row.remarks;
      this.curriculumRow.sort_num = row.sort_num;
      this.curriculumRow.subject_id = row.subject_id;
      this.curriculumRow.title = row.title;
      this.curriculumRow.url = row.url;
      this.curriculumRow.ppt_url = row.ppt_url;
      this.curriculumRow.teaching_materials_url = row.teaching_materials_url;
      if (row.video_url_first) {
        this.curriculumRow.video_url_first = [
          {
            name: row.video_url_first.split(".com")[1],
            url: row.video_url_first,
          },
        ];
      } else {
        this.curriculumRow.video_url_first = [];
      }
      if (row.video_url_second) {
        this.curriculumRow.video_url_second = [
          {
            name: row.video_url_second.split(".com")[1],
            url: row.video_url_second,
          },
        ];
      } else {
        this.curriculumRow.video_url_second = [];
      }

      this.curriculumRowIndex = index;
      this.dialogVisible = true;
    },
    // 获取课程体系详情
    getCurriculumInfo() {
      getCurriculumInfo({
        curriculum_id: this.$route.query.id,
      }).then((res) => {
        this.ruleForm.curriculum_name = res.curriculum[0].title;
        this.curriculum_name = res.curriculum[0].title;
        this.ruleForm.subject_id = res.curriculum[0].subject_id;
        this.ruleForm.teaching_type = res.curriculum[0].teaching_type;
        this.ruleForm.sort_num = res.curriculum[0].sort_num;
        this.ruleForm.number_of_courses = res.curriculum[0].number_of_courses;
        this.ruleForm.curriculum_url = JSON.parse(
          res.curriculum[0].curriculum_data_url
        );
        this.ruleForm.curriculum_classes_list = res.curriculum_material_list;
      });
    },
    // 编辑确定
    addSubject() {
      if (!this.curriculumRow.title) {
        this.$message.warning("请填写课程名称");
        return;
      }
      if (!this.curriculumRow.ppt_url) {
        this.$message.warning("请上传PPT");
        return;
      }
      this.ruleForm.curriculum_classes_list[
        this.curriculumRowIndex
      ].created_time = this.curriculumRow.created_time;
      this.ruleForm.curriculum_classes_list[
        this.curriculumRowIndex
      ].curriculum_id = this.curriculumRow.curriculum_id;
      this.ruleForm.curriculum_classes_list[
        this.curriculumRowIndex
      ].id = this.curriculumRow.id;
      this.ruleForm.curriculum_classes_list[
        this.curriculumRowIndex
      ].remarks = this.curriculumRow.remarks;
      this.ruleForm.curriculum_classes_list[
        this.curriculumRowIndex
      ].sort_num = this.curriculumRow.sort_num;
      this.ruleForm.curriculum_classes_list[
        this.curriculumRowIndex
      ].subject_id = this.curriculumRow.subject_id;
      this.ruleForm.curriculum_classes_list[
        this.curriculumRowIndex
      ].title = this.curriculumRow.title;
      this.ruleForm.curriculum_classes_list[
        this.curriculumRowIndex
      ].url = this.curriculumRow.url;
      this.ruleForm.curriculum_classes_list[
        this.curriculumRowIndex
      ].ppt_url = this.curriculumRow.ppt_url;
      this.ruleForm.curriculum_classes_list[
        this.curriculumRowIndex
      ].teaching_materials_url = this.curriculumRow.teaching_materials_url;
      if (
        this.curriculumRow.video_url_first[0] &&
        this.curriculumRow.video_url_first[0].url
      ) {
        this.ruleForm.curriculum_classes_list[
          this.curriculumRowIndex
        ].video_url_first = this.curriculumRow.video_url_first[0].url;
      }
      if (
        this.curriculumRow.video_url_second[0] &&
        this.curriculumRow.video_url_second[0].url
      ) {
        this.ruleForm.curriculum_classes_list[
          this.curriculumRowIndex
        ].video_url_second = this.curriculumRow.video_url_second[0].url;
      }

     // this.updateCurriculumInfo("edit");






    },
    // 获取科目
    getUserSubjectList() {
      getUserSubjectList().then((res) => {
        this.subjectList = res.base_platform.concat(res.mechanism_platform);
      });
    },
    // 编辑取消
    quitAddSubject() {
      this.curriculumRow.created_time = null;
      this.curriculumRow.curriculum_id = null;
      this.curriculumRow.id = null;
      this.curriculumRow.remarks = null;
      this.curriculumRow.sort_num = null;
      this.curriculumRow.subject_id = null;
      this.curriculumRow.title = null;
      this.curriculumRow.url = null;
      this.curriculumRow.ppt_url = "";
      this.curriculumRow.teaching_materials_url = "";
      this.curriculumRow.video_url_first = [];
      this.curriculumRow.video_url_second = [];
      this.curriculumRowIndex = 0;
      this.dialogVisible = false;
    },
    uploadFile() {},
    handleRemove(file, fileList, status) {
      if (status === "curriculum_url") {
        this.ruleForm.curriculum_url = fileList;
      } else {
        this.curriculumRow[status] = fileList;
      }
    },
    async handleChangeFile(file, fileList, status, index) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status, index);
      }
    },
    async uploadFileOss(list, status) {
      this.uploadFileTime = true;
      await uploadFile(list,this.$store.state.user.userInfo.code).then((res) => {
        if (status === "curriculum_url") {
          this.ruleForm.curriculum_url = res;
        } else {
          this.curriculumRow[status] = res;
        }
        this.uploadFileTime = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.createCurriculumSystem {
  width: 100%;
  background-color: #ffffff;
  padding: 20px;
  box-sizing: border-box;
  .title {
    font-size: 24px;
    font-weight: bold;
    margin: 20px 0 0 20px;
  }
  .table-style {
    padding-bottom: 20px;
  }
}
</style>
